import pmenu from '../../../../api/pmenu'
import Add from './add.dialog.vue'

export default {
  components: {
    Add
  },
  data() {
    return {
      dataSource: [],
      isVisable: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.dataSource = await pmenu.getAll()
    },
    add(val) {
      this.isVisable = true
      if (val.id) {
        this.$refs['publisher-policy-add'].setParentId(val.id)
      }
    },
    edit(val) {
      this.$refs['publisher-policy-add'].getQuery(val.id)
      this.isVisable = true
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this policy?',
        content:
          'Please be aware of once this policy is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await pmenu.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Policy has been deleted!'
        })
        this.getList()
      })
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await pmenu.setSort(val)
      this.getList()
    }
  }
}
